import { observable, action, computed } from 'mobx';
import TB from '@tiger/bridge';
import cookick from 'cookick';
import http from 'utils/http';
import API from 'utils/API';
import URL from 'utils/URL';
import type { CurrentUser } from 'types/UserStatus';
import ui from 'stores/ui';

const SECURITY = 'TIGER_US_PORTAL_SECURITY';

export function getCurrentUser(cookick) {
    return {
        isIBClearing: cookick.getCookie('isIBClearing') === '1',
        isLogin: cookick.getCookie('isLogin') === '1'
    };
}

export class Security {
    currentUser: CurrentUser = getCurrentUser(cookick);

    @observable
    customInfo: any = null; // 用户信息

    @computed
    get isLogin() {
        return !!this.ACCESS_TOKEN;
    }

    @observable ACCESS_TOKEN: string | null;
    VERIFY_TOKEN: string | null;

    isMarscoAccount = true;

    async init() {
        try {
            if (window.TigerBridge) {
                await TB.ready;
            }

            // 是老虎app的话，就通过TigerBridge尝试去获取token
            const TigerBridge = window.TigerBridge;

            // 获取token
            this.ACCESS_TOKEN = TigerBridge.getAccessToken();
        } catch (error) {
            const authLocalStorage = localStorage.getItem(SECURITY);

            // 使用localStorage中的token，不存在则为null
            try {
                this.ACCESS_TOKEN = authLocalStorage ? JSON.parse(authLocalStorage).token : null;
            } catch (err) {}
        }
    }

    /**
     * 清除登录的状态
     */
    clearAuth() {
        localStorage.removeItem(SECURITY);

        this.ACCESS_TOKEN = null;
    }

    @action
    logout() {
        this.clearAuth();
    }

    /**
     * deep link 唤起 app & 下载 app 链接
     */

    @observable
    downloadUrl: string = '';

    /**
     * 获取 deeplink
     */
    @action.bound
    getDownloadUrl = async (num: number = 0) => {
        try {
            const { url } = await http
                .post(
                    API.GUESS.getDeepLink(),
                    {
                        data_$desktop_url: URL.merge(window.location.href, {
                            pathname: '/market/gp2t',
                            query: {
                                jump: true
                            }
                        })
                    },
                    { useForm: true }
                )
                .then(res => res.data || {});

            this.downloadUrl = url;
        } catch {
            // 生成失败，继续尝试2次
            num <= 2 && this.getDownloadUrl(++num);
        }
    };

    goToTrade = async () => {
        if (ui.isTiger) {
            const link = this.isLogin ? '/trade' : '/loginPageFromInviteAct';

            TB.goNativePage(link);
        } else {
            await new Promise(res => {
                const timer = setInterval(() => {
                    if (this.downloadUrl) {
                        clearInterval(timer);
                        res('');
                    }
                }, 500);
            });

            window.location.href = this.downloadUrl;
        }
    };
}

export default new Security();
